import { Heading } from '@shieldpay/bumblebee/heading';
import { Text } from '@shieldpay/bumblebee/text';

import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.titles.bumblebee',
});

export default function Home() {
  return (
    <>
      <Heading>Introduction</Heading>
      <Text paragraph>The library is open</Text>
    </>
  );
}
